<template>
    <div class="row" id="banks" ref="bank_block" v-if="merchant.bank_relationship === 'BUSINESS'">
        <div class="col-12">
            <div class="panel-sub-heading headingLarge">
                <span class="markedBottom">{{!!title ? title : lang('banks') }}</span>
            </div>
        </div>
        <div class="col-md-6 col-12" v-for="(bank, bank_idx) in merchant.business_entity.banks" :key="bank_idx">
            <div class="card">
                <div class="card-header">
                    <span class="card-title">{{lang(bank.bank_account_type)}}</span>
                    <np-checkbox class="float-right float-end"
                                 v-if="bank.bank_account_type === 'BILLING'"
                                 :id="`checking_account_as_deposit`"
                                 :name="`checking_account_as_deposit`"
                                 ref="billing_same_as_deposit_bank"
                                 @change="copyDepositToBilling"
                                 :description="lang('same_as_deposit_bank')"
                                 :value="'1'"
                                 :no-wrapper="true"
                                 v-model="bank.copy_other_account">
                    </np-checkbox>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-12">
                            <np-input :id="`bank_sort_code_${bank_idx}`"
                                      :name="`bank_sort_code_${bank_idx}`"
                                      :label="lang('sort_code')"
                                      :rules="['integer']"
                                      :required="true"
                                      :disabled="bank.bank_account_type === 'BILLING' && bank.copy_other_account ==='1'"
                                      @input="validateBank(bank)"
                                      v-model="bank.sort_code">
                            </np-input>
                            <np-input :id="`bank_account_number_${bank_idx}`"
                                      :name="`bank_account_number_${bank_idx}`"
                                      :label="lang('account_number')"
                                      :rules="['integer']"
                                      :required="true"
                                      @input="validateBank(bank)"
                                      v-model="bank.account_number">
                            </np-input>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="card">
                                <!--                                   TODO get the height of the form div and make this card match or be horizontally centered.-->
                                <div class="card-body py-2">
                                               <span>{{bank.bank_name}} <br>{{bank.street_line_1}} <br>
                                                   {{`${bank.bank_city},`}} {{`${bank.county_code},`}}
                                                   {{`${bank.zip_code},`}}
                                                   <br> {{formatCountry(bank.country_code)}}
                                               </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bank",
        props: {
            title: {
                default: '',
                type: String,
            },
            banks: [],

        }
    }
</script>

<style scoped>

</style>
